export default __webpack_public_path__ + "static/EG_Galano_Infura-a9cafd6821cb2891903158cbc9770d47.jpeg";